import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-form11-sidebar',
  templateUrl: './form11-sidebar.component.html',
  styleUrls: ['./form11-sidebar.component.scss']
})
export class Form11SidebarComponent {
  @Input() currentStep: number
  @Input() stepsCovered: number[] = []
  @Input() hideSteps: number[] = []

  @Output() currentStepEvent = new EventEmitter<number>()

  steps = [
    { id: 1, label: 'Upload Documents' },
    { id: 2, label: 'Personal Details' },
    { id: 3, label: 'Contact Details' },
    { id: 4, label: 'Previous EPFO Details' },
    { id: 5, label: 'Download Form 11' }
  ]

  moveTo(stepId: number) {
    this.currentStepEvent.emit(stepId)
  }

  isCompleted(stepId: number) {
    return this.stepsCovered.includes(stepId)
  }

  getVisibleSteps() {
    return this.steps.filter(step => !this.hideSteps.includes(step.id))
  }
}
